const FONT_SIZE = {
  SMALL: '12px',
  MEDIUM: '14px',
  LARGE: '16px',
  XLARGE: '20px',
  XXLARGE: '24px',
  XXXLARGE: '32px',
  XL4: '40px',
}

const LINE_HEIGHT = {
  SMALL: '16px',
  MEDIUM: '16px',
  LARGE: '24px',
  XLARGE: '28px',
  XXLARGE: '28px',
  XXXLARGE: '40px',
  XL4: '56px',
}

const FONT_WEIGHT = {
  REGULAR: '400',
  BOLD: '700',
}

const DEFAULT_FONT_STACK = `
  font-family: 'Wix Madefor Text', 'Lucida Grande', 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif;
`

const DEFAULT_FONT_STACK_FOR_JS =
  "'Wix Madefor Text', 'Lucida Grande', 'Helvetica Neue', Helvetica, Arial, Verdana, sans-serif"

const FONT_BOLD = `
  ${DEFAULT_FONT_STACK}
  font-weight: ${FONT_WEIGHT.BOLD};
`

const FONT_REGULAR = `
  ${DEFAULT_FONT_STACK}
  font-weight: ${FONT_WEIGHT.REGULAR};
`

export {
  FONT_SIZE,
  LINE_HEIGHT,
  FONT_WEIGHT,
  DEFAULT_FONT_STACK,
  DEFAULT_FONT_STACK_FOR_JS,
  FONT_BOLD,
  FONT_REGULAR,
}
